import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import "../../../LeadNew/LeadDetail/LenderPrivacyPolicy/LenderPrivacyPolicy.scss";
import { getEnumList, numberWithCommas } from "shared/services/Utility";
import iconAction from "../../../../../assets/images/action.svg";
import iconPlus from "../../../../../assets/images/add_round.svg";
import { RangePickerProps } from "antd/es/date-picker";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import API_SERVICE from "shared/services/api-service";
import { NUMBER_REGEX } from "shared/constants/AppConstants";


interface IPrivacyPolicyPanel {
  lender: any;
  productPlans?: any;
  lenderIndex?: any;
  updateCase: any;
  showAdd: boolean;
  loanType: string;
  onClickAdd?: React.MouseEventHandler<HTMLElement>;
  setIsLoading:any;
  leadData:any
  productPlanName:any
  setProductPlanName:any
  productPlanId:any;
  setproductPlanId:any
  annualFee:any
  selectedLender:any
  lenderFullData: any;
}

const PrivacyPolicyPanel: React.FC<IPrivacyPolicyPanel> = (
  props: IPrivacyPolicyPanel
) => {
  const { lender, productPlans, lenderIndex, updateCase, showAdd, loanType, onClickAdd, setIsLoading, leadData,productPlanName,setProductPlanName,productPlanId, setproductPlanId, lenderFullData, annualFee} =
    props;
  const [policyStatusKey, setPolicyStatusKey] = useState("");
  const [errorCoverTenure, setErrorCoverTenure] = useState(false);
  const [errorPremiumTenure, setErrorPremiumTenure] = useState(false);
  const [formPrivacyPolicy] = Form.useForm();
  const [lenders, setLenders] = useState([
    ...leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails,
  ] as any);
  const withdrawnReasons = getEnumList("INSURANCE_WITHDRAWN_REASON");
  const frequencyPaymentList = getEnumList("FREQUENCY_OF_PAYMENT");
  const dateFormat = "DD/MM/YYYY";
  const [subProductDetails, setSubProductDetails] =  useState([]) as any
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const [creditCardRejectReasons, setCreditCardRejectReasons] = useState([] as any);
  const [creditCardPendencyReasons, setCreditCardPendencyReasons] = useState([] as any);
  const [creditCardWithdrawnReasons, setCreditCardWithdrawReasons] = useState([] as any);
  const [statusReason, setStatusReason] = useState("")
  const [annualFees, setAnnualFees] = useState("")
  const [limit, setLimit] = useState("")
  const [applicationNumber, setApplicationNumber] = useState("")
  const [sanctionedDate, setSanctionedDate] = useState("") as any
  const [cardIssuedDate, setCardIssuedDate] = useState("") as any
  const [productPlanData, setProductPlanData] = useState([]) as any
  const [productPlanListData, setProductPlanListData] = useState([]) as any;
  const policyStatusList = [
    {
      key: "POLICY_ISSUED",
      value: "Policy Issued",
    },
    {
      key: "UNDERWRITING_REJECT",
      value: "Underwriting Reject",
    },
    {
      key: "COUNTER_OFFER",
      value: "Counter Offer",
    },
    {
      key: "WITHDRAWN",
      value: "Withdrawn",
    },
  ];

  const creditCardStatusList = [
    {
      key: "SANCTIONED",
      value: "Sanctioned",
    },
    {
      key: "REJECTED",
      value: "Rejected",
    },
    {
      key: "PENDENCY",
      value: "Pendency",
    },
    {
      key: "WITHDRAWN",
      value: "Withdrawn",
    },
  ];


useEffect(() => {
  if(lender?.subProductDetails!=null){
    getProductsPlans();  
  //   const tmpLender = lenders.map((lender: any) => {
  //     return lender?.subProductDetails?.subProductDetails
  //     //   setSubProductDetails(subProduct)
       
  //     // return ;
  // });
  //   let tmpLender1 = (Array.isArray(tmpLender))
  //     setSubProductDetails(tmpLender)
  //   console.log('lendertmp', tmpLender, tmpLender1)
    // const subProductDetails = tmpLender?.subProductDetails?.subProductDetails;
   
   
  }
 }, [subProductDetails,lender] );

  useEffect(() => {
    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const rejectedReasonList = enumValues.find(
        (item) => item.propertyName === "REJECTION_REASON"
      );
      const rejectedReasonListDisplay =
        rejectedReasonList.keyAndDisplayValueList?.filter((item: any) => {
          return (
            item?.key == "FRAUD_CASE" ||
            item?.key == "LOAN_SIZE_SMALL" ||
            item?.key == "LIMIT_EXHAUSTED" ||
            item?.key == "INCOMPLETE_DOCUMENTS" ||
            item?.key == "VERTICAL_NOT_SUPPORTED" ||
            item?.key == "CREDIT_SCORE_INSUFFICIENT" ||
            item?.key == "OUTSIDE_GEOGRAPHIC_JURISDICTION" ||
            item?.key == "DUPLICATE"
          );
      });
      setCreditCardRejectReasons(rejectedReasonListDisplay);
      const pendencyReasonList = enumValues?.find(
        (item) => item?.propertyName === "PENDENCY_REASON"
      );
      setCreditCardPendencyReasons(pendencyReasonList?.keyAndDisplayValueList);
      const withdrawnReasonList = enumValues?.find(
        (item) => item?.propertyName === "WITHDRAWN_REASON"
      );
      let tmpReasons = withdrawnReasonList?.keyAndDisplayValueList
      const updatedReasons = tmpReasons.filter(
        (item) => item.key !== "HIGHER_LOAN_AMOUNT_REQUIRED"
      );
      setCreditCardWithdrawReasons(updatedReasons);
    }
    setFormData();
  }, [lender]);

  
  const getProductsPlans = () => {
    const subProducts = lender?.subProductDetails?.subProductDetails || [];
    setIsLoading(true);
    let payload = {
      lenderIds: lenders?.map((lender: any) => lender?.lenderInfoId)?.join(","),
      loanProductId: leadData?.loanProductId,
      status: "ACTIVE"
    };
    API_SERVICE.getLenderListInsurer(payload)
      .then(({ data }) => {
        setProductPlanData(data)
        const productPlanList = data?.payload ?? [];

    const planMap = new Map();
    productPlanList.forEach((lender) => {
      lender.productPlanDetails.forEach((plan) => {
        planMap.set(plan.productPlanId, plan.productPlanName);
      });
    });
    const values: any = {};
    subProducts?.forEach((item, i) => {
      const planName = planMap.get(item?.productPlanId);
      values[`productPlanId${i}`] =  planName ? planName : "";
      values[`policyStatus${i}`] = lender?.status === "LOGGED" || lender?.status === "ASSIGNED"? "" : lender?.status;
      values[`applicationNumber${i}`] = item?.applicationNumber;
      values[`limit${i}`] = item?.limit;
      values[`annualFee${i}`] = item?.annualFee;
      values[`sanctionedDate${i}`] = lender?.sanctionedDate
        ? moment(lender?.sanctionedDate)
        : null;
    setProductPlanName(planName)        
    });
    formPrivacyPolicy.setFieldsValue(values);
    const fullDetailsArray = subProducts.map((item) => {
      return {
        planId:item.productPlanId,
        limit: item.limit,
        annualFee: item.annualFee,
        applicationNumber: item.applicationNumber,
        cardIssuedDate:item.cardIssuedDate,
        sanctionedDate:lender?.sanctionedDate!=null ?(moment(lender?.sanctionedDate, 'YYYY-MM-DD')):null
      };
    });
    setProductPlanListData(fullDetailsArray);  
    setApplicationNumber(fullDetailsArray[0]?.applicationNumber)  
    setLimit(fullDetailsArray[0]?.limit)
    setAnnualFees(fullDetailsArray[0]?.annualFee)
    // setSanctionedDate(moment(lender?.sanctionedDate, 'YYYY-MM-DD'))
    setSanctionedDate(fullDetailsArray[0]?.sanctionedDate)
    setCardIssuedDate(fullDetailsArray[0]?.cardIssuedDate)
        })
        .catch((e: any) => {
          notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setIsLoading(false));
  };

  const setFormData = () => {
    if (["LOGGED"].includes(lender?.status)) {
      return;
    }

    const insuranceDetails = lender?.insuranceDetails;
    const subProductDetails = lender?.subProductDetails?.subProductDetails || [];
    setSubProductDetails(subProductDetails)
   
    if (!insuranceDetails) {
      setPolicyStatusKey(lender?.status);
      // formPrivacyPolicy.setFieldsValue({
      //   productPlanId: productPlanName,
      //   policyStatus:lender?.status
      // })
      return;
    }
      const iDate = insuranceDetails.policyIssuedDate;
      const eDate = insuranceDetails.policyEndDate;
      formPrivacyPolicy.setFieldsValue({
        productPlanId: insuranceDetails.productPlanId,
        policyIssuedDate: iDate && moment(iDate, dateFormat),
        policyEndDate: eDate && moment(eDate, dateFormat),
        grossPremiumAmount: insuranceDetails.grossPremiumAmount,
        frequencyOfPayment: insuranceDetails.frequencyOfPayment,
        premiumTenureYear: insuranceDetails.premiumTenure?.years,
        premiumTenureMonth: insuranceDetails.premiumTenure?.months,
        maturitySumInsured: insuranceDetails.maturitySumInsured,
        coverTenureYear: insuranceDetails.coverTenure?.years,
        coverTenureMonth: insuranceDetails.coverTenure?.months,
        counterOfferPremium: insuranceDetails.counterOfferPremium,
        policyNumber: insuranceDetails.policyNumber,
        proposalApplicationNumber: insuranceDetails.proposalApplicationNumber,
        policyStatus: insuranceDetails.policyStatus,
        policyStatusComments: insuranceDetails.policyStatusComments,
      });
      
    setPolicyStatusKey(insuranceDetails?.policyStatus);
  };

  const onFinish = (values: any) => {
    const yearcover = formPrivacyPolicy.getFieldValue("coverTenureYear");
    const monthcover = formPrivacyPolicy.getFieldValue("coverTenureMonth");
    const isErrorcover = (monthcover == 0 && yearcover == 0);
    setErrorCoverTenure(isErrorcover)

    const yearpremium = formPrivacyPolicy.getFieldValue("premiumTenureYear");
    const monthpremium = formPrivacyPolicy.getFieldValue("premiumTenureMonth");
    const isErrorpremium = (monthpremium == 0 && yearpremium == 0);
    setErrorPremiumTenure(isErrorpremium)

    if(values?.policyStatus == "POLICY_ISSUED" && (isErrorcover || isErrorpremium || errorCoverTenure || errorPremiumTenure)) {
      return;
    }    

    const plan = productPlans?.find(
      (plan: any) => plan?.productPlanId === values?.productPlanId
    );
    const insuranceDetails = {
      ...values,
      productPlanName: plan?.productPlanName,
      policyEndDate: values?.policyEndDate
        ? moment(values?.policyEndDate).format(dateFormat).toString()
        : "",
      policyIssuedDate: values?.policyIssuedDate
        ? moment(values?.policyIssuedDate).format(dateFormat).toString()
        : "",
      premiumTenure: {
        months: values?.premiumTenureMonth,
        years: values?.premiumTenureYear,
      },
      coverTenure: {
        months: values?.coverTenureMonth,
        years: values?.coverTenureYear,
      },
    };
    const subProductDetails = {
      // ...values,
      productPlanId: productPlanListData[0]?.planId,
      applicationNumber: applicationNumber,
      limit:limit && limit.toString(),
      annualFee: formPrivacyPolicy?.getFieldValue("annualFee0")
    };
    let tmpLender
    if (tenantInfo?.businessProductType === "INSURANCE"){
      tmpLender = {
        insuranceDetails: { insuranceDetails: [insuranceDetails] },
        comments: "",
        status: values?.policyStatus,
        lenderActivityId: lender?.lenderActivityId,
        lenderInfoId: lender?.lenderInfoId,
        lenderName: lender?.lenderName,
      };
    }
    else{
      tmpLender = {
        subProductDetails: { subProductDetails: [subProductDetails] }, //: null,
        comments: (policyStatusKey === "WITHDRAWN" || policyStatusKey === "PENDENCY") ? statusReason : "",
        status: policyStatusKey,
        lenderActivityId: lender?.lenderActivityId,
        lenderInfoId: lender?.lenderInfoId,
        lenderName: lender?.lenderName,
        sanctionedDate:policyStatusKey === "SANCTIONED" ? moment(sanctionedDate).format("YYYY-MM-DD") : null,
        rejectedReason:(policyStatusKey === "REJECTED") ? statusReason : "",
      }
    }
    updateCase(tmpLender);
    setSanctionedDate(policyStatusKey != "SANCTIONED"?null:sanctionedDate)
    setproductPlanId( productPlanListData[0]?.planId)
   };

 const renderActionBtn = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <Button
          type="text"
          style={{ backgroundColor: "transparent", border: "none" }}
          icon={<img src={iconPlus} alt="" height={20} width={20} />}
          hidden={!showAdd || tenantInfo?.businessProductType != "INSURANCE"}
          onClick={onClickAdd}
        />
        <Form.Item name="action" className="" style={{ marginBottom: "0px" }}>
          <Button
            type="text"
            htmlType="submit"
            style={{ backgroundColor: "transparent", border: "none" }}
            icon={<img src={iconAction} alt="" height={20} width={20}/>}
          />
        </Form.Item>
      </div>
    );
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return (
      moment().add(-5, "years") >= current ||
      moment().add(5, "years") <= current
    );
  };

  const disabledEndDate: RangePickerProps["disabledDate"] = (current) => {
    const idate = formPrivacyPolicy.getFieldValue("policyIssuedDate");
    if (idate != null) {
      return current?.isBefore(moment(idate));
    }
    return !(current && current > moment().endOf("day"));
  };

  const setEndDate = () => {
    const idate = formPrivacyPolicy.getFieldValue("policyIssuedDate");
    const year = formPrivacyPolicy.getFieldValue("coverTenureYear");
    const month = formPrivacyPolicy.getFieldValue("coverTenureMonth");
    const isError = (month == 0 && year == 0);
    setErrorCoverTenure(isError)
    if (idate != null && !isError) {
      formPrivacyPolicy.setFieldsValue({
        policyEndDate: moment(idate).add(year, "years").add(month, "months").subtract(1, "day"),
      });
    }
  };

  const changePremium = () => {
    const year = formPrivacyPolicy.getFieldValue("premiumTenureYear");
    const month = formPrivacyPolicy.getFieldValue("premiumTenureMonth");
    const isError = (month == 0 && year == 0);
    setErrorPremiumTenure(isError)
  };

  const renderCreditCardSanctionedFields = (item:any, i:number) => {
    // let tmpDate = lender?.sanctionedDate ? moment(lender?.sanctionedDate, 'YYYY-MM-DD') : null;
    const flatAnnualFee = annualFee.flat();
    let cardAnnualFee = flatAnnualFee.find((card) => card.planId === item?.productPlanId)?.annualFee || "";
    let annual_fee = cardAnnualFee//item?.annualFee;
    if(!annual_fee) {
      const offerlist =  lenderFullData?.lenderSubProductOfferDetailsList
      const findProduct = offerlist?.find((offer: any) => offer?.productPlanId == item?.productPlanId)
      annual_fee = findProduct?.aggregatorOfferDetails?.aggregatorOfferDetails?.at(0)?.offerDetails?.annual_fee;
    }
    formPrivacyPolicy.setFieldsValue({
     [ `annualFee${i}`]: annual_fee
    })
    return (
      <>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name= {`applicationNumber${i}`}
            className="decision-item privacy-policy-label"
            label={"Application No."}
            rules={[
                  {
                    required:true,
                    message:"Please enter Application No"
                  }
            ]}
            // initialValue={item && item?.applicationNumber}
          >
            <Input 
              className="custom-input"
              value={item && item?.applicationNumber}
              onChange={(e)=>setApplicationNumber(e?.target?.value)} />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
            <Form.Item
              name={`limit${i}`}
              label="Limit"
              className="decision-item privacy-policy-label"
              style={{ flex: 1 }}
              rules={[
                  { 
                    required: true, 
                    message: "Please enter Limit"
                 },
                {
                  pattern:NUMBER_REGEX,
                  message:"Enter a valid limit"
                }          
              ]}
              // initialValue={item && item?.limit}
            >
              <Input
                className="custom-input"
                value={numberWithCommas(limit)}
                onChange={(e)=> setLimit(e?.target?.value)}
              />
            </Form.Item>
         </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`annualFee${i}`}
            className="decision-item privacy-policy-label"
            label="Annual Fee"
            initialValue={annual_fee}
          >
            <Input
              className="custom-input"
              // disabled={lender?.insuranceDetails?.grossPremiumAmount}
              // formatter={(value) => numberWithCommas(value)}
              value = {annual_fee}
              onChange={(e)=>setAnnualFees(e?.target?.value)}
              readOnly
            />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`sanctionedDate${i}`}
            label="Sanctioned Date"
            className="decision-item privacy-policy-label"
            rules={[{ required: true }]}            
          >
            <DatePicker
              style={{
                width: "98%",
                marginLeft: "3px",
                marginBottom: "5px",
              }}
              format={dateFormat}
              disabledDate={disabledDate}
              className="custom-input"
              onChange={(value)=>setSanctionedDate(value)}
              disabled={cardIssuedDate!=null}
              // value={lenderSanctionedDate}
            />
          </Form.Item>
        </Col>        
      </>
   
    );
  }
  const renderPrivacyPolicySelectFields = () => {
    return (
      <>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={"policyNumber"}
            className="decision-item privacy-policy-label"
            label={"Policy No."}
            rules={[
                  {
                    required:tenantInfo?.businessProductType != "INSURANCE",
                    message:"Please enter Application No"
                  }
            ]}
          >
            <Input 
              className="custom-input"
           />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <span className="field-lable privacy-policy-label">
            <span className="star">*</span> Cover Tenure(In Years-Months)
          </span>
          <div style={{ display: "flex", gap: "6px" }}>
            <Form.Item
              name={`coverTenureYear`}
              className="decision-item privacy-policy-label"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please enter year" }
                , {
                  validator: (_, value) => {
                    if (value > 100) {
                      return Promise.reject(new Error("Please enter years upto 100"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                className="custom-input-number"
                onBlur={() => setEndDate()}
              />
            </Form.Item>
            <Form.Item
              className="decision-item privacy-policy-label"
              name={`coverTenureMonth`}
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please enter month" }]}
            >
              <Select className="custom-select" onChange={() => setEndDate()}>
                {Array.from(Array(12).keys()).map((item) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          {errorCoverTenure &&
            <div style={{fontSize:'10px', color:'red', marginTop:"-6px"}}>
              Min 1 month required
            </div>
          }
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`policyIssuedDate`}
            label="Policy Issue Date"
            className="decision-item privacy-policy-label"
            rules={[{ required: true }]}
          >
            <DatePicker
              style={{
                width: "98%",
                marginLeft: "3px",
                marginBottom: "5px",
              }}
              format={dateFormat}
              // disabledDate={disabledDate}
              className="custom-input"
              onChange={() => setEndDate()}
              // placeholder="DD-MM-YYYY"
            />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`policyEndDate`}
            label="Policy End Date"
            className="decision-item privacy-policy-label"
            rules={[{ required: true }]}
          >
            <DatePicker
              style={{
                width: "98%",
                marginLeft: "3px",
                marginBottom: "5px",
              }}
              format={dateFormat}
              className="custom-input"
              disabledDate={disabledEndDate}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`grossPremiumAmount`}
            className="decision-item privacy-policy-label"
            label="Gross Premium Amount"
            rules={[{ required: true }]}
          >
            <InputNumber
              className="custom-input-number"
              disabled={lender?.insuranceDetails?.grossPremiumAmount}
              formatter={(value) => numberWithCommas(value)}
            />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            className="decision-item privacy-policy-label"
            label="Frequency Of Payment"
            name={`frequencyOfPayment`}
            rules={[{ required: true }]}
          >
            <Select className="custom-select">
              {frequencyPaymentList?.map((item) => (
                <Select.Option key={item?.key} value={item?.key}>
                  {item?.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <span className="field-lable privacy-policy-label">
            <span className="star">*</span> Premium Tenure(In Years-Months)
          </span>
          <div style={{ display: "flex", gap: "6px" }}>
            <Form.Item
              name={`premiumTenureYear`}
              className="decision-item privacy-policy-label"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please enter year" }
                , {
                  validator: (_, value) => {
                    if (value > 100) {
                      return Promise.reject(new Error("Please enter years upto 100"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber className="custom-input-number" onBlur={() => changePremium()}/>
            </Form.Item>
            <Form.Item
              className="decision-item privacy-policy-label"
              name={`premiumTenureMonth`}
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please select month" }]}
            >
              <Select className="custom-select" onChange={() => changePremium()}>
                {Array.from(Array(12).keys()).map((item) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          {errorPremiumTenure &&
            <div style={{fontSize:'10px', color:'red', marginTop:"-6px"}}>
              Min 1 month required
            </div>
          }
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`maturitySumInsured`}
            className="decision-item privacy-policy-label"
            label="Maturity/Sum Insured"
          >
            <InputNumber
              className="custom-input-number"
              name="maturitySumInsured"
              formatter={(value) => numberWithCommas(value)}
            />
          </Form.Item>
        </Col>
      </>
       
    
    );
  };

  const renderRejectedView = () => {
    return (
      <>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`proposalApplicationNumber`}
            className="decision-item privacy-policy-label"
            label="Proposal Application No."
          >
            <Input className="custom-input" />
          </Form.Item>
        </Col>
        <Col span={24} xs={24} xl={18}>
          <div className="rejected-wrapper">
            <Form.Item
              name={`policyStatusComments`}
              label="Rejection Reason"
              className="privacy-policy-form-item"
            >
              <TextArea className="custom-textarea" rows={1} />
            </Form.Item>
          </div>
        </Col>
      </>
    );
  };

  const renderCreditCardRejectedView = (item:any, i:number) =>{
    return (
      <>
        <Col span={12} xs={12} xl={6}>
        <div className="decision-item privacy-policy-label">
          <Form.Item
            name={`rejectedReason${i}`}
            label={"Rejected Reason"}
            rules={[
              {
                required: true,
                message: "Please select reason",
              },
            ]}
            initialValue={lender?.rejectedReason}
          >
            <Select
              className="custom-select"
              showSearch
              placeholder="Select Reason"
              optionFilterProp="children"
              onChange={(value)=>setStatusReason(value)}
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {creditCardRejectReasons?.map((item) => (
                <Select.Option
                  key={item.key}
                  value={item.key}
                >
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          </div>
          
        </Col>
        <Col span={12} xs={12} xl={6}>
        <Form.Item
            name={`applicationNumber${i}`}
            className="decision-item privacy-policy-label"
            label="Application No."
            initialValue={item?.applicationNumber}
          >
            <Input className="custom-input"
            onChange={(e)=>setApplicationNumber(e?.target?.value)} />
          </Form.Item>
         
        </Col>
      </>
    );
  }

  const renderCreditCardWithdraw = (item:any,i:number) => {
    return (
      <>
        <Col span={6} xs={24} xl={6}>
          <div className="decision-item privacy-policy-label">
            <Form.Item
              name={`withdrawnReason${i}`}
              label="Withdrawn Reason"
              className="privacy-policy-form-item"
              initialValue={lender?.comments}
            >
              <Select
                className="custom-select"
                showSearch
                placeholder="Select Reason"
                optionFilterProp="children"
                onChange={(value)=>setStatusReason(value)}
              >
                {creditCardWithdrawnReasons?.map((item) => (
                  <Select.Option key={item?.key} value={item?.key}>
                    {item?.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`applicationNumber${i}`}
            className="decision-item privacy-policy-label"
            label="Application No."
            initialValue={item?.applicationNumber}
          >
            <Input className="custom-input" 
            onChange={(e)=>setApplicationNumber(e?.target?.value)}/>
          </Form.Item>
        </Col>

      </>
    );
  };

  const renderWithdraw = () => {
    return (
      <>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`proposalApplicationNumber`}
            className="decision-item privacy-policy-label"
            label="Proposal Application No."
          >
            <Input className="custom-input" />
          </Form.Item>
        </Col>
        <Col span={6} xs={24} xl={6}>
          <div className="rejected-wrapper">
            <Form.Item
              name={`policyStatusComments`}
              label="Withdrawn Reason"
              className="privacy-policy-form-item"
            >
              <Select
                className="custom-select"
                showSearch
                placeholder="Select Reason"
                optionFilterProp="children"
              >
                {withdrawnReasons?.map((item) => (
                  <Select.Option key={item?.key} value={item?.key}>
                    {item?.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Col>
      </>
    );
  };

  const renderCreditCardPendency = (item:any, i:number) => {
    return (
      <>
        <Col span={6} xs={24} xl={6}>
          <div className="decision-item privacy-policy-label">
            <Form.Item
              name={`pendencyReason${i}`}
              label="Pendency Reason"
              className="privacy-policy-form-item"
              initialValue={lender?.comments}
            >
              <Select
                className="custom-select"
                showSearch
                placeholder="Select Reason"
                optionFilterProp="children"
                onChange={(value)=>setStatusReason(value)}
              >
                {creditCardPendencyReasons?.map((item) => (
                  <Select.Option key={item?.key} value={item?.key}>
                    {item?.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`applicationNumber`}
            className="decision-item privacy-policy-label"
            label="Application No."
            initialValue={item?.applicationNumber}
          >
            <Input className="custom-input"
            onChange={(e)=>setApplicationNumber(e?.target?.value)} />
          </Form.Item>
        </Col>

      </>
    );
  };

  const renderCounterOffer = () => {
    return (
      <>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            name={`proposalApplicationNumber`}
            className="decision-item privacy-policy-label"
            label="Proposal Application No."
          >
            <Input className="custom-input" />
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            className="decision-item privacy-policy-label"
            label="Frequency Of Payment"
            name={`frequencyOfPayment`}
          >
            <Select className="custom-select">
              {frequencyPaymentList?.map((item) => (
                <Select.Option key={item?.key} value={item?.key}>
                  {item?.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6} xs={12} xl={6}>
          <Form.Item
            className="decision-item privacy-policy-label"
            label="Counter Offer Premium"
            name={`counterOfferPremium`}
          >
            <InputNumber
              className="custom-input-number"
              name="counterOfferPremium"
              formatter={(value) => numberWithCommas(value)}
            />
          </Form.Item>
        </Col>
      </>
    );
  };

  const renderCreditCardDetails = (prod :any, i:number) =>{
   return(
      <div className="lender-privacy-policy-main-div">             
          <Row gutter={[6, 6]} style={{ rowGap: "1px" }}>
            <Col span={6} xs={12} xl={6}>
              <Form.Item
                className="decision-item privacy-policy-label"
                label="Product Plan"
                name={`productPlanId${i}`}
                // rules={[{ required: true}]}
                // initialValue={productPlaneName}
                
              >
                <Input
                  className="custom-input"
                  // value={productPlanName}
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col span={6} xs={12} xl={6}>
              <Form.Item
                className="decision-item privacy-policy-label"
                label={"Status"}
                name={`policyStatus${i}`}
                rules={[{ required: true }]}
                initialValue={lender?.status === "LOGGED" || lender?.status === "ASSIGNED" ? "" : lender?.status}
              >
                <Select
                  className="custom-select"
                  onSelect={(ev: any) => setPolicyStatusKey(ev)}
                  value={lender?.status === "LOGGED"  || lender?.status === "ASSIGNED"? "" : lender?.status}
                  // onChange={(e)=>setStatus(e?.target?.value)}
                >
                  {creditCardStatusList?.map((item) => (
                    <Select.Option key={item?.key} value={item?.key}>
                      {item?.value}
                    </Select.Option>
                  ))}
                  </Select>
                </Form.Item>
              </Col>
              {policyStatusKey === "SANCTIONED" &&
                renderCreditCardSanctionedFields(prod,i)}
              {policyStatusKey === "REJECTED" &&
                renderCreditCardRejectedView(prod,i)}
              {policyStatusKey === "WITHDRAWN" && 
                renderCreditCardWithdraw(prod,i)}
              {policyStatusKey === "PENDENCY" && 
              renderCreditCardPendency(prod,i)}
          </Row>  
      </div>
    )
  }

  const renderCreditCardFields=()=>{
    if ((lender?.subProductDetails?.subProductDetails?.length ?? 0) === 0) {
      return null;
    }
  
    return (
      <li key={lenderIndex} style={{ marginTop: "0px" }}>
        <Form form={formPrivacyPolicy} layout="vertical" onFinish={onFinish}>
          <div className="lender-privacy-policy-header">
            {lender?.lenderName}
            {renderActionBtn()}
          </div>
          {lender.subProductDetails.subProductDetails.map((prod, index) =>
            renderCreditCardDetails(prod, index)
          )}
        </Form>
      </li>
    );
  };
  

  const renderPrivacyPanel = () => {
    return (
      <li key={lenderIndex} style={{ marginTop: "-0px" }}>
        <Form form={formPrivacyPolicy} layout="vertical" onFinish={onFinish}>
          <div className="lender-privacy-policy-header">
            {lender?.lenderName}
            {renderActionBtn()}
          </div>
          {tenantInfo?.businessProductType === "INSURANCE" ? (
            <div className="lender-privacy-policy-main-div">
              <Row gutter={[6, 6]} style={{ rowGap: "1px" }}>
                <Col span={6} xs={12} xl={6}>
                  <Form.Item
                    className="decision-item privacy-policy-label"
                    label="Product Plan"
                    name={`productPlanId`}
                   // rules={[{ required: true }]}
                  >
                    
                    <Select className="custom-select">
                      {productPlans?.map((item) => (
                        <Select.Option
                          key={item?.productPlanId}
                          value={item?.productPlanId}
                        >
                          {item?.productPlanName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6} xs={12} xl={6}>
                  <Form.Item
                    className="decision-item privacy-policy-label"
                    label={"Policy Status"}
                    name={`policyStatus`}
                    rules={[{ required: true }]}
                  >
                    <Select
                      className="custom-select"
                      onSelect={(ev: any) => setPolicyStatusKey(ev)}
                    >
                      {policyStatusList?.map((item) => (
                        <Select.Option key={item?.key} value={item?.key}>
                          {item?.value}
                        </Select.Option>
                      ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {policyStatusKey === "POLICY_ISSUED" &&
                    renderPrivacyPolicySelectFields()}
                  {policyStatusKey === "UNDERWRITING_REJECT" &&
                    renderRejectedView()}
                  {policyStatusKey === "WITHDRAWN" && renderWithdraw()}
                  {policyStatusKey === "COUNTER_OFFER" && renderCounterOffer()}
              </Row>
            </div>
            ) : (
              (lender?.subProductDetails?.subProductDetails?.length) > 0 ? (
                subProductDetails.map((prod,index)=>(
                  renderCreditCardDetails(prod,index)
                )) 
              )  : (
               ""// renderCreditCardDetails([],0)
              )
             )}
        </Form>
      </li>
    );
  };

  return <>{ leadData?.loanType != "Credit Card" ? renderPrivacyPanel() : renderCreditCardFields()}</>;
};
export default PrivacyPolicyPanel;
